export default "__VITE_ASSET__gcfGvzXo__"